import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PaymentLandingComponent } from './components';

const routes: Routes = [
  {
    path: '',
    component: PaymentLandingComponent,
    data: {
      page_name: 'payment_page',
      category: 'donation'
    }
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PayementRoutingModule { }
